import styled from 'styled-components';
import { FlexColumn } from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';

export const Container = styled(FlexColumn)`
  margin: 20px 0;
  padding: 15px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
  gap: 10px;
`;

export const InfoRow = styled(Typography)`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
